module.exports = __webpack_public_path__ + "img/banner2.2d7b01b8.png";